import { render, staticRenderFns } from "./DomainLayout.vue?vue&type=template&id=68d8d900"
import script from "./DomainLayout.vue?vue&type=script&lang=js"
export * from "./DomainLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports